// ------------------------------------------
// FVのスクロール演出
// ------------------------------------------
class FvScroll {
  constructor(el, opt) {
    this.root = document.querySelector('.' + el);
    if (this.root) {
      this.event();
    }
  }

  event() {
    const fv = this.root;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    const body = document.body;
    const shade = fv.querySelector('.js-fv-shade');
    const shadeBlur = fv.querySelector('.js-fv-shade-blur');
    const hero = fv.querySelector('.js-fv-hero');
    const pagination = fv.querySelector('.js-fv-pagination');
    const lead = fv.querySelector('.js-fv-lead');
    const concept = fv.querySelector('.js-fv-concept');

    const mm = gsap.matchMedia();
    mm.add({ isSp: '(max-width: 767px)', isPc: '(min-width: 768px)' }, (context) => {
      const { isSp } = context.conditions;
      const blurIn = 0.5;
      const heroFadeStart = isSp ? 0.35 : 0.62;
      const heroFade = isSp ? 0.4 : 0.26;
      // SPは1スクロール程度で演出が見えるよう距離を短くする
      const scrollLength = isSp ? 0.9 : 1.6;
      const scrub = isSp ? 0.6 : 1.5;
      const tl = gsap.timeline({
        defaults: { ease: 'none' },
        onUpdate: () => {
          if (isScrollLocked()) return;
          body.classList.toggle('is-fv-blur', tl.progress() >= heroFadeStart + heroFade);
        },
        scrollTrigger: {
          trigger: lead,
          start: 'top top',
          end: () => `+=${window.innerHeight * scrollLength}`,
          scrub,
          invalidateOnRefresh: true,
        },
      });

      const header = document.querySelector('.js-header');
      ScrollTrigger.create({
        trigger: fv,
        start: 'bottom bottom',
        onEnter: () => {
          if (isScrollLocked()) return;
          body.classList.add('is-fv-passed');
          if (header) header.classList.add('is-hidden');
        },
        onLeaveBack: () => {
          if (isScrollLocked()) return;
          body.classList.remove('is-fv-passed');
        },
      });

      tl.to(pagination, { autoAlpha: 0, duration: 0.4 }, 0)
        .to(shade, { opacity: 0, duration: blurIn }, 0)
        .to(shadeBlur, { opacity: 1, duration: blurIn }, 0)
        .to(hero, { autoAlpha: 0, duration: heroFade }, heroFadeStart);

      gsap.fromTo(concept, { autoAlpha: 0 }, {
        autoAlpha: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: concept,
          start: 'top 100%',
          end: 'top 60%',
          scrub: 1,
        },
      });

      return () => body.classList.remove('is-fv-blur', 'is-fv-passed');
    });
  }
}
